'use strict'

/**
 * @NOTE : This doesn't work on chrome, cf https://bugs.chromium.org/p/chromium/issues/detail?id=783382#c3
 * but it's okey for firefox
 */
export default function (): void {
  try {
    const opener = window.opener as WindowOpener
    if (opener && window.location.hostname === opener.location.hostname && window.history.length === 1) {
      const pathName = window.location.pathname
      const hash = window.location.hash

      window.history.replaceState(
        { forceRefresh: true },
        '', // <= unused argument but we must pass somehting (cf doc)
        opener.location.href
      )
      window.history.pushState(
        { forceRefresh: true },
        '', // <= unused argument but we must pass somehting (cf doc)
        pathName + hash
      )
    }
  } catch (exception) {
    console.error(exception)
  }
}
